<template>
  <v-dialog
    :value="shownDownloadMobileAppPopup"
    v-on:click:outside="onRejectDownloadMobileAppPopup"
  >
    <div class="mobile-modal">
      <div class="mobile-modal__wrap">
        <p class="mobile-modal__wrap__title">Установить МИС на телефон</p>
        <p>Записывайте пациентов на прием с мобильного устройства в любое удобное время.</p>
        <p>Установите приложение МИС32top на рабочий стол телефона.</p>
        <button
          type="button"
          class="mobile-modal__cross"
          @click="onRejectDownloadMobileAppPopup"
          aria-label="Закрыть окно"
        />
        <div class="mobile-modal__buttons">
          <router-link
            class="mobile-modal__buttons__download"
            target="_blank"
            v-on:click.native="onAcceptDownloadMobileAppPopup"
            :to="{ name: 'ClinicPanelHelp', query: { pwa: true } }">
            Установить
          </router-link>
          <button
            class="mobile-modal__buttons__cancel"
            type="button"
            v-on:click="onRejectDownloadMobileAppPopup">Не сейчас</button>
        </div>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import {
  INITIAL_MOBILE_POPUP,
  USER_ACCEPT_MOBILE_DOWNLOAD_POPUP,
  USER_REJECT_MOBILE_DOWNLOAD_POPUP,
} from '@/store/actions/mobilePopup';
import MobileMixin from '@/mixins/mobileMixin';

export default {
  computed: {
    /**
     * @description Показывать ли всплывающее окно скачивания мобильного приложения.
     * @returns {boolean}
     */
    shownDownloadMobileAppPopup() {
      return this.$store.getters.getMobileDownloadPopup.is_show
        && this.$route.name !== 'ClinicPanelHelp'
        && this.isMobile;
    },
  },
  beforeCreate() {
    this.$store.dispatch(INITIAL_MOBILE_POPUP);
  },
  methods: {
    /**
     * @description Обработать закрытие всплывающего окна скачивания мобильного приложения.
     * @returns {void}
     */
    onRejectDownloadMobileAppPopup() {
      this.$store.dispatch(USER_REJECT_MOBILE_DOWNLOAD_POPUP);
    },
    /**
     * @description Обработать принять установку мобильного приложения.
     * @returns {void}
     */
    onAcceptDownloadMobileAppPopup() {
      this.$store.dispatch(USER_ACCEPT_MOBILE_DOWNLOAD_POPUP);
    },
  },
  mixins: [
    MobileMixin,
  ],
};

</script>
<style scoped lang="scss">
@use "@/scss/buttons";
.mobile-modal {
  p {
    margin-bottom: 20px !important;
  }
  &__buttons {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
    &__cancel {
      @include buttons.btn-transparent(100%, 46px, 1rem);
    }
    &__download {
      @include buttons.btn-blue(100%, 46px, 1rem);
      text-decoration: none;
      color: white !important;
      gap: 10px;
      &:before {
        content: "";
        width: 20px;
        height: 20px;
        background-image: url("@/assets/img/download-white.svg");
        background-position: center;
        background-size: contain;
      }
    }
  }
  &__cross {
    position: absolute;
    right: 15px;
    top: 15px;
    cursor: pointer;
    background-image: url("@/assets/img/exit-black.svg");
    background-repeat: no-repeat;
    background-size: contain;
    width: 17px;
    height: 17px;
  }
}
.mobile-modal__wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  min-width: 300px;
  max-width: 500px;
  background: #ffffff;
  box-shadow: 0px -4px 18px rgb(33, 33, 33);
  border-radius: 8px;
  padding: 40px 30px 30px;
  transition: .3s cubic-bezier(.25,.8,.25,1);
  transform: translate(-50%, -50%);
  &__title {
    justify-content: center;
    font-size: 17px;
    font-weight: 600;
    text-align: center;
  }
  &__title + p{
    margin-bottom: 6px !important;
  }
}

</style>
